(() => {
  angular
    .module('gm.common.directives')
    .directive('gmStrongPassword', gmStrongPasswordDirective);

  function gmStrongPasswordDirective(
    $window,
    gettextCatalog,
    angularLoad
  ) {
    'ngInject';

    const zxcvbnLibPath = '/js/libs/zxcvbn.js';
    const additionalStrings = [
      'bitgold',
      'bitgold.com',
      'goldmoney',
      'goldmoney.com'
    ];

    /* Need this list for helping gettext finds strings */
    gettextCatalog.getString('Use a few words, avoid common phrases');
    gettextCatalog.getString('No need for symbols, digits, or uppercase letters');
    gettextCatalog.getString('Add another word or two. Uncommon words are better.');
    gettextCatalog.getString('Straight rows of keys are easy to guess');
    gettextCatalog.getString('Short keyboard patterns are easy to guess');
    gettextCatalog.getString('Use a longer keyboard pattern with more turns');
    gettextCatalog.getString('Repeats like "aaa" are easy to guess');
    gettextCatalog
      .getString('Repeats like "abcabcabc" are only slightly harder to guess than "abc"');
    gettextCatalog.getString('Avoid repeated words and characters');
    gettextCatalog.getString('Sequences like abc or 6543 are easy to guess');
    gettextCatalog.getString('Avoid sequences');
    gettextCatalog.getString('Recent years are easy to guess');
    gettextCatalog.getString('Avoid recent years');
    gettextCatalog.getString('Dates are often easy to guess');
    gettextCatalog.getString('Avoid years that are associated with you');
    gettextCatalog.getString('Avoid dates and years that are associated with you');
    gettextCatalog.getString('This is a top-10 common password');
    gettextCatalog.getString('This is a top-100 common password');
    gettextCatalog.getString('This is a very common password');
    gettextCatalog.getString('This is similar to a commonly used password');
    gettextCatalog.getString('A word by itself is easy to guess');
    gettextCatalog.getString('Names and surnames by themselves are easy to guess');
    gettextCatalog.getString('Common names and surnames are easy to guess');
    gettextCatalog.getString('Capitalization doesn\'t help very much');
    gettextCatalog.getString('All-uppercase is almost as easy to guess as all-lowercase');
    gettextCatalog.getString('Reversed words aren\'t much harder to guess');
    gettextCatalog
      .getString('Predictable substitutions like \'@\' instead of \'a\' don\'t help very much');

    return {
      require: 'ngModel',
      restrict: 'A',

      link(scope, _element, _attrs, ctrl) {
        function init() {
          const zxcvbn = $window.zxcvbn;

          scope.$watch(
            () => ctrl.$modelValue || ctrl.$$invalidModelValue || '',
            (password) => {
              const result = zxcvbn(password, additionalStrings);

              ctrl.strength = result;
              ctrl.$setValidity('strength', result.score >= 3);
            }
          );
        }

        ctrl.strength = null;

        angularLoad.loadScript(zxcvbnLibPath)
          .then(init);
      },
    };
  }
})();
